import { LocalCache, StorageKey } from "../../../../../../shared/cache/LocalCache"
import { MeetingAudienceFilterType } from "../../../../../../shared/components/filters/orderTypeFilter/helpers"
import { OrganizerType } from "../../../../../../shared/types/OrganizerTypes"
import { MeetingAudience, ServiceCenterBookingOrganizer } from "../../serviceCenterHomeTypes"

export function loadMeetingAudienceFilter(): MeetingAudienceFilterType {
    const stored = LocalCache().get(StorageKey.SERVICE_CENTER_MEETING_AUDIENCE_FILTER)
    return Object.values(MeetingAudienceFilterType).find((filter) => filter === stored) ?? MeetingAudienceFilterType.ALL
}

export function saveMeetingAudienceFilter(filter: MeetingAudienceFilterType) {
    LocalCache().set(StorageKey.SERVICE_CENTER_MEETING_AUDIENCE_FILTER, filter)
}

export function toAudienceParam(filter: MeetingAudienceFilterType): MeetingAudience | undefined {
    return filter === MeetingAudienceFilterType.ALL ? undefined : filter
}

export function toMeetingAudience(isExternal?: boolean): MeetingAudience | undefined {
    if (isExternal === undefined) return undefined
    return isExternal ? MeetingAudienceFilterType.EXTERNAL : MeetingAudienceFilterType.INTERNAL
}

export function getHostOrganizerName(organizers?: Array<ServiceCenterBookingOrganizer>) {
    if (!Array.isArray(organizers) || organizers.length === 0) return ""

    const responsible = organizers.find((org) => org?.type === OrganizerType.RESPONSIBLE && org?.name)
    if (responsible) return responsible.name

    const organizer = organizers.find((org) => org?.type === OrganizerType.ORGANIZER && org?.name)
    return organizer ? organizer.name : ""
}

export function getHostOrganizer(
    organizers?: Array<ServiceCenterBookingOrganizer>,
): ServiceCenterBookingOrganizer | null {
    if (!Array.isArray(organizers) || organizers.length === 0) return null

    const responsible = organizers.find((org) => org?.type === OrganizerType.RESPONSIBLE && org?.name)
    const organizer = organizers.find((org) => org?.type === OrganizerType.ORGANIZER && org?.name)
    return responsible ?? organizer ?? null
}

export function getHostOrganizerCompanyName(organizers?: Array<ServiceCenterBookingOrganizer>) {
    if (!Array.isArray(organizers) || organizers.length === 0) return ""

    const responsible = organizers.find((org) => org?.type === OrganizerType.RESPONSIBLE && org?.company?.name)
    if (responsible) return responsible.company?.name

    const organizer = organizers.find((org) => org?.type === OrganizerType.ORGANIZER && org?.company?.name)
    return organizer ? organizer.company?.name : ""
}
